export enum AppRoutesEnum {
  HOME = '/',
  TLDR_DATE = '/:date',
  ERROR = '/error'
}
